import React, { useState } from 'react';

import { Callout as BPCallout, Intent, Button } from '@blueprintjs/core';

interface Props {
  intent?: Intent;
  message: string;
}

const DismissibleCallout = ({ intent, message }: Props) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <BPCallout intent={intent}>
      <Button
        variant="minimal"
        size="small"
        icon="small-cross"
        className="absolute top-8 right-8 z-1"
        onClick={() => setIsVisible(false)}
        aria-label="Dismiss"
      />
      {message}
    </BPCallout>
  );
};

export default DismissibleCallout;
